var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloneCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2 10.2H7.65C3.42503 10.2 0 13.625 0 17.85V43.35C0 47.5751 3.42503 51 7.65 51H33.15C37.3751 51 40.8 47.5751 40.8 43.35V40.8H43.35C47.5751 40.8 51 37.3751 51 33.15V7.65C51 3.42503 47.5751 0 43.35 0H17.85C13.625 0 10.2 3.42503 10.2 7.65V10.2ZM15.3 10.2H33.15C37.3751 10.2 40.8 13.625 40.8 17.85V35.7H43.35C44.7584 35.7 45.9 34.5584 45.9 33.15V7.65C45.9 6.24169 44.7584 5.1 43.35 5.1H17.85C16.4417 5.1 15.3 6.24166 15.3 7.65V10.2ZM5.1 43.35C5.1 44.7584 6.24169 45.9 7.65 45.9H33.15C34.5584 45.9 35.7 44.7584 35.7 43.35V17.85C35.7 16.4417 34.5584 15.3 33.15 15.3H7.65C6.24169 15.3 5.1 16.4417 5.1 17.85V43.35Z",
    fill: "#1EC252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneCopy);
export default __webpack_public_path__ + "static/media/CloneCopy.d3ac23a4.svg";
export { ForwardRef as ReactComponent };